import type {AddComponentTypeOptions} from 'grapesjs';
import {CONFIRMATION_PANEL_BUTTON_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_CONFIRMATION_PANEL_BUTTON_TYPE = 'postermywall-confirmation-panel-button-text';
const CONFIRMATION_PANEL_BUTTON_ID = 'postermywall-confirmation-panel-button';
const FORM_BUTTON_DATA_ATTR = 'data-is-pmw-form-button';
const DEFAULT_CONFIRMATION_CTA = 'Submit another response';

export const POSTERMYWALL_CONFIRMATION_PANEL_BUTTON: AddComponentTypeOptions = {
  extend: 'text',
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    const isButtonTag = el.tagName === 'BUTTON' || el.tagName === 'INPUT';
    return isButtonTag && el.getAttribute(FORM_BUTTON_DATA_ATTR) !== null && el.id === CONFIRMATION_PANEL_BUTTON_ID
      ? {type: POSTERMYWALL_CONFIRMATION_PANEL_BUTTON_TYPE}
      : undefined;
  },
  model: {
    defaults: {
      tagName: 'button',
      name: window.i18next.t('pmwjs_form_maker_name_button'),
      icon: 'icon-button',
      removable: false,
      toolbar: [],
      selectable: true,
      highlightable: false,
      badgable: true,
      editable: true,
      draggable: false,
      content: DEFAULT_CONFIRMATION_CTA,
      attributes: {
        id: CONFIRMATION_PANEL_BUTTON_ID,
        [FORM_BUTTON_DATA_ATTR]: '1',
        'data-pmw-type': POSTERMYWALL_CONFIRMATION_PANEL_BUTTON_TYPE,
        class: 'pmw-content-button js-resubmit-button',
        type: 'button',
      },
      style: CONFIRMATION_PANEL_BUTTON_STYLES,
    },
  },
};
